import { setDuplicateKey } from '../State/duplicate'

export default (key, value) => (dispatch) => {
  
  dispatch(setDuplicateKey({ key, value }))
  
}
